import { useEffect } from "react";
import { useLocation } from "react-router";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const layoutElement = document.querySelector(".ant-layout");
    if (layoutElement) {
      layoutElement.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [pathname]);
}

export default ScrollToTop;
